import { ToastrService } from "ngx-toastr";

import { SimpleNotificationComponent, SimpleNotificationParams } from './simple-notification.component';
import { MobileSimpleNotificationComponent } from '../mobile-simple-notification/mobile-simple-notification.component';

export function ShowSimpleNotification(toastr: ToastrService, params: SimpleNotificationParams, mobileMode: string = 'desktop')
{
    const mobile = mobileMode != 'desktop';
    let config = Object.assign(toastr.toastrConfig, {});
    config.timeOut = 6000;
    config.progressBar = true;
    config.closeButton = true;
    config.toastComponent = mobile? MobileSimpleNotificationComponent: SimpleNotificationComponent;
    return toastr.show(JSON.stringify(params), '', config);
}